import { Box, Typography } from '@mui/material';

type Props = {
  completedHosts: number;
  totalHosts: number;
};

export const ProgressBarDisplay = ({ completedHosts, totalHosts }: Props) => {
  const progress = totalHosts !== 0 ? Math.floor((completedHosts / totalHosts) * 100) : 0;

  return (
    <Box
      sx={{
        background: progress !== 100 ? `linear-gradient(270deg, #FFFFFF ${100 - progress}%, #90ee90 100%)` : '#90ee90',
        width: '7rem',
        height: '2rem',
        borderRadius: '3px',
        border: '1px solid',
      }}
    >
      <Typography variant="subtitle1" component="p" sx={{ pl: 0.5 }}>
        {`${completedHosts}/${totalHosts}`}
      </Typography>
    </Box>
  );
};
